var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"id":"includes_anonymous","name":"includes_anonymous","value":1,"unchecked-value":0},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},[_vm._v(" Allow Includes Anonymous User ")])
}
var staticRenderFns = []

export { render, staticRenderFns }